module.exports = __webpack_public_path__ + "img/80424405.17212380.png";